import {useRef, useEffect} from "react";
import {Button, Group, Modal, Text} from "@mantine/core";
import {Trans, useTranslation} from "react-i18next";
import type {Status} from "../../types";
import {getStatusDisplayName} from "../statusNames";

type ConfirmCheckAllModalProps = {
    opened: boolean;
    onClose: () => void;
    onConfirm: () => void;
    status: Status;
};

export const ConfirmCheckAllModal = ({
    opened,
    onClose,
    onConfirm,
    status,
}: ConfirmCheckAllModalProps) => {
    const {t} = useTranslation();
    const cancelRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (opened) {
            setTimeout(() => cancelRef.current?.focus(), 50);
        }
    }, [opened]);

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Modal opened={opened} onClose={onClose} title={t("Label.ConfirmAction")}>
            <Text>
                <Trans
                    i18nKey="Warning.AboutToMarkAllChecklistItems"
                    values={{status: getStatusDisplayName(status)}}
                    components={{strong: <strong />}}
                />
            </Text>
            <Group justify="space-between" mt="lg">
                <Button variant="subtle" onClick={onClose} ref={cancelRef}>
                    {t("common.cancel")}
                </Button>
                <Button onClick={handleConfirm}>{t("Word.Confirm")}</Button>
            </Group>
        </Modal>
    );
};
